import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
export const ACCIONES_AT_CLIENTE = [
    {
        id: 'accept',
        label: 'Aceptar',
        icon: CheckCircleOutlineIcon,
        color: '#215732',
        title: 'Aceptar y derivar a finanzas',
        description:
            'El cliente acepta la alternativa. Tramitar rectificativa, vale, nueva venta o devolución.',
        placeholder: 'Instrucciones adicionales para el equipo de finanzas...',
        required: false,
        buttonLabel: 'Confirmar y derivar',
    },
    {
        id: 'reject',
        label: 'Rechazar',
        icon: CancelOutlinedIcon,
        color: '#c62828',
        title: 'Rechazar alternativa',
        description:
            'El cliente no acepta. Cerrar la solicitud indicando el motivo.',
        placeholder: 'Describe el motivo del rechazo...',
        required: true,
        requiredMessage: 'Detalles sobre el motivo del rechazo...',
        buttonLabel: 'Confirmar rechazo',
    },
    {
        id: 'requestInfo',
        label: 'Más info',
        icon: HelpOutlineIcon,
        color: '#1565c0',
        title: 'Solicitar más información',
        description:
            'Pedir fotos, referencias o aclaraciones adicionales al recambista.',
        placeholder: 'Describe exactamente que necesitas que el recambista aporte o confirme...',
        required: true,
        requiredMessage:
            'Escribe un comentario con la información que necesitas.',
        buttonLabel: 'Enviar solicitud',
    },
];

export const getActionById = (id) =>
    ACCIONES_AT_CLIENTE.find((a) => a.id === id);

export const API_ACCION_BY_UI_ID = {
    accept: 'accept',
    reject: 'reject',
    requestInfo: 'request_info',
};
